import { render, staticRenderFns } from "./OrderDestinationDeleteConfirm.vue?vue&type=template&id=76a12f3a&"
import script from "./OrderDestinationDeleteConfirm.vue?vue&type=script&lang=js&"
export * from "./OrderDestinationDeleteConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports